import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postMethod } from "../../services/ApiCallMethods";

export const downloadReports = createAsyncThunk(
  "reportsDownload/downloadReports",
  async ({ reportIds }, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/investor-reports/download`, { reportIds });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "reports.zip");

      document.body.appendChild(link);
      link.click();
      link.remove();

      return true;
    } catch (error) {
      console.error("Error downloading reports:", error);
      return rejectWithValue(error?.response?.data || "Failed to download reports");
    }
  }
);

const initialState = {
  downloadLoading: false,
  downloadError: null,
  downloadSuccess: false,
};

const reportsDownloadSlice = createSlice({
  name: "reportsDownload",
  initialState,
  reducers: {
    resetReportsDownloadState: (state) => {
      state.downloadLoading = false;
      state.downloadError = null;
      state.downloadSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadReports.pending, (state) => {
        state.downloadLoading = true;
        state.downloadError = null;
        state.downloadSuccess = false;
      })
      .addCase(downloadReports.fulfilled, (state) => {
        state.downloadLoading = false;
        state.downloadSuccess = true;
      })
      .addCase(downloadReports.rejected, (state, action) => {
        state.downloadLoading = false;
        state.downloadError = action.payload;
        state.downloadSuccess = false;
      });
  },
});

export const { resetReportsDownloadState } = reportsDownloadSlice.actions;

export default reportsDownloadSlice.reducer;
